import React, { useEffect, useState } from 'react';
import { UseFormReturn } from 'react-hook-form';
import FormDropDownPicker from '../../FormDropDownPicker';
import FilterCheckboxList, { FilterListItem } from './FilterCheckboxList';
import { accessService } from '../../../services/central-api/access';

type Props = {
    actingBodyId: number | null;
} & ({
    form?: undefined;
    fieldName?: undefined;
    customValidations?: undefined;
    pattern?: undefined;
    value: number[];
    setValue: React.Dispatch<React.SetStateAction<number[]>>;
} | {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    form: UseFormReturn<any, any, any>;
    fieldName: string;
    value?: undefined;
    setValue?: undefined;
});

function DispatchActingBodiesCommandsList({ value, setValue, actingBodyId, form, fieldName }: Props) {
    const [items, setItems] = useState<FilterListItem[]>([]);
    const [isLoading, setIsLoading] = useState(true);

    async function getActingBodyCommands({ actingBodyId }: { actingBodyId: number; }) {
        try {
            setIsLoading(true);
            const actingBody = await accessService.getActingBody(actingBodyId);
            if (!actingBody.actingBodyCommands) {
                setItems([]);
            } else {
                setItems(actingBody.actingBodyCommands.map((role) => ({
                    value: role.id || 0,
                    label: role.name
                })));
            }
        } catch (err) {
            console.error(err);
        } finally {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        if (actingBodyId) {
            getActingBodyCommands({ actingBodyId });
        } else {
            setIsLoading(false);
        }
    }, [actingBodyId]);

    if (form && fieldName) {
        return <FormDropDownPicker
            items={items}
            multiple={true}
            mode='BADGE'
            fieldName={fieldName}
            form={form}
            zIndex={1}
        />;
    } else if (value !== undefined && setValue !== undefined) {
        return <FilterCheckboxList items={items} value={value} setValue={setValue} isLoading={isLoading} />;
    }

    return null;
}

export default DispatchActingBodiesCommandsList;
